// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 432) return "content/plugin-rig-shifts/371649e89e29a0ef2d0199d1742ed686.js";
	// return url for filenames based on template
	return undefined;
};